/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2PhoneChat from 'DesignSystem/Svgs/Tysiav2PhoneChat/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsContactMethods/Content/Item/Phone",
  isSubmitting
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let contactMethodsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'contact_methods',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting,
  isHovered
  
})
let contactMethodValueData = fromData.useDataFormat({ viewPath,
context: 'contact_method',
format: fromFormat.personPhone,
})
  return (<React.Fragment
>
<button
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={contactMethodsIsSubmittingData}
 style={{'--pt-1-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-5-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-6-5yCzy': isHovered ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2PhoneChat
  viewPath={`${viewPath}/Tysiav2PhoneChat`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={isHovered ? "semibold" : "normal"}
 data="contact_method"
 format="/Data/format.js personPhone"
 text={contactMethodValueData}
/>
</button>
{children}
</React.Fragment>)
}